import React from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../store';
import { LocationVipCostsDto } from '../../store/vipUsersSlice';

interface Props {
    laundryRoom?: LocationVipCostsDto;
}

function VipLaundryRoomInfoCard(props: Readonly<Props>) {
    return (
        <div className={'card level-1'}>
            <div className="card-content">{maybeRenderContent()}</div>
        </div>
    );

    function maybeRenderContent() {
        if (!props.laundryRoom) {
            return null;
        }

        return (
            <>
                {props.laundryRoom.laundry_room_name}
                <br />
                {props.laundryRoom.address}
            </>
        );
    }
}

export default connect(
    (store: RootState) => ({
        laundryRoom: store.vipUsers.locationVipPricing,
    }),
    {}
)(VipLaundryRoomInfoCard);
